import { inject, Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { toObservable } from '@angular/core/rxjs-interop';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { AuthStore } from '../state/auth/auth.store';

@Injectable({
  providedIn: 'root',
})
export class LoginGuard {
  private authStore = inject(AuthStore);
  private router = inject(Router);

  canActivate(
    pathIfLoggedIn: string
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.getIsLoggedIn(pathIfLoggedIn);
  }

  private getIsLoggedIn(pathIfLoggedIn: string): Observable<boolean> {
    return toObservable(this.authStore.isLoggedIn).pipe(
      filter((isLoggedIn: boolean | null) => isLoggedIn !== null),
      map((isLoggedIn) => {
        if (isLoggedIn) {
          this.router.navigate([pathIfLoggedIn]);
          return false;
        } else {
          return true;
        }
      })
    );
  }
}
